/**
 * @author  : 王冲
 * @desc    : passport -- utils
 */

/**
 * 模块后端标识与地址映射（应用管理对照前台地址部分）
 */
// 一级路由重叠的需要把长路由放前面，避免匹配错误
export const moduleRouteMap = [
    'task::/task::/mobile/task',
    'workflow::/workflow::/mobile/workflow',
    'mainline::/project::/mobile/project',
    'document::/doc/::/mobile/doc/',
    'customer::/crm/customer::/mobile/crm/customer',
    'contact::/crm/contact::/mobile/crm/contact',
    'saleChance::/crm/salechance::/mobile/crm/salechance',
    'production::/crm/production::/mobile/crm/production',
    'competitor::/crm/competitor::/mobile/crm/competitor',
    'clue::/crm/clue::/mobile/crm/clue',
    'contract::/crm/contract::/mobile/crm/contract',
    'crmSummary::/crm/crmSummary::/mobile/crm/crmSummary',
    'marketactivity::/crm/marketactivity::/mobile/crm/marketactivity',
    'orderform::/crm/orderform::/mobile/crm/orderform',
    'price::/crm/price::/mobile/crm/price',
    'capital::/crm/capital::/mobile/crm/capital',
    'quote::/crm/quote::/mobile/crm/quote',
    'blog::/blog::/mobile/blog',
    'calendar::/calendar::/mobile/calendar',
    'workreport::/plan::/mobile/plan',
    // 'statisticalReport::/statistics::/mobile/statistics',
    'wechatEnterprise::/eb/weworkauth::/mobile/eb/weworkauth',
    'form::/formreport::/mobile/formreport',
    'wechatService::/eb/wechatservice::/mobile/eb/wechatservice',
    'attend::/attend::/mobile/attend',
    'sms::/sms::/mobile/sms',
    'saleTarget::/goal::/mobile/goal',
    'salarybill::/hrm/dispatchPayroll::/mobile/hrm/salary',
    'placard::/placard::/mobile/placard',
    'staffPosition::/cus/position',
    'app::/paas/app::--',
    'email::/mail::/mobile/mail',
    'hr::/hrm/employeeManager::--',
    'hr::/hrm/contractManager::--',
    'hr::/hrm/hr/::--',
    'hr::/hrm/archiveSetting::--',
    'hr::--::/mobile/hrm/contractManager',
    'kpi::/performance::/mobile/performance',
    'tag::/my/tag::/mobile/my/tag',
    'meeting::/meeting::/mobile/meeting/calendar',
    'signcontract::/signcenter::/mobile/signcenter',
    'inc::/inc::/mobile/inc',
    'scrm::/market::/mobile/market',
    'fnabank::/fnaentbank::/mobile/fnaentbank',
    'fna::/fna/::/mobile/fna',
    'okr::/goal/::/mobile/goal',
    'cloudstore::/cloudstore::/mobile/cloudstore',
    'cowork::/cowork::/mobile/cowork',
    'scene::/scene::/mobile/scene',
    'hrmsalary::/salary::/mobile/salary',//薪酬管理
    'odocexchange::/odocexchange::--',
    'odoc::/odoc::/mobile/odoc',
    'wait::/my/wait::/mobile/my/wait',
    'portal::/portal::/mobile/portal',
    'customerservice::/customerservice::/mobile/custom/customerservice',
    'bpm::/bussinessflow::--',//端到端业务流
    'portrait::/portrait::/mobile/portrait',
    'docCompared::/doccompare::/mobile/doccompare',
    'analyze::/analyze::/mobile/analyze',
    // 'statpage::/statpage::/mobile/statpage',
];
/**
 * 模块后端标识与地址映射（后台管理部分）
 */
export const managerRouteMap = [
    'workflow::/info/engine_wf::--',
    'document::/info/app_doc/docSetting::--',
    'saleChance::/info/app_salechance/setting::--',
    'orderform::/info/app_orderform/orderformSetting::--',
    'capital::/info/app_capital/capitalSetting::--',
    'portal::/info/app_portal/::--',
    'workreport::/info/app_plan/plan/setting::--',
    'scrm::/info/app_scrm/setting/::--',
    'mainline::/info/app_project/settings::--',
    'cowork::/info/app_cowork/bsSet::--',
    'marketactivity::/info/app_marketactivity/setting::--',
    'production::/info/app_production/setting::--',
    'quote::/info/app_quote/setting::--',
    'kpi::/info/app_hrm/setting::--',
    'hr::/info/app_hr/::--',
    'signcontract::/info/signcenter/SettingsIndex::--',
    'saleTarget::/info/app_okr::--',
    'task::/info/app_task/settings::--',
    'odoc::/info/app_odoc/odocengine::--',
    'clue::/info/app_clue/setting::--',
    'competitor::/info/app_competitor/setting::--',
    'sms::/info/app_sms::--',
    'attend::/info/app_attend/settingPage::--',
    'inc::/info/app_inc/setConfig::--',
    'fnabank::/info/fnaentbank/setting::--',
    'calendar::/info/app_calendar::--',
    'customer::/info/app_customer/customerSetting::--',
    'contract::/info/app_contract/setting::--',
    'price::/info/app_price/priceSetting::--',
    'email::/info/app_mail::--',
    'blog::/info/app_blog/blogsetting::--',
    'fna::/info/fna/setting::--',
    'portrait::/info/portrait/set::--',
    'esb::/info/esb::--',
    'datamodel::/info/dw/::--',
    'ebridge::/info/eb/::--',
    'intunifytodoc::/info/todoclient::--',
    'intunifytodos::/info/todocenter::--',
    'FB031::/info/app_synergy/synergy::--',
    'intunifyauth::/info/authclient::--',

    'voice::/info/custom_voice/voice::--',
    'im::/info/im/::--',
    'em::/info/em/::--',
    'datasecurity::/info/dataSecurity::--',
    'authority::/info/role::--',
    'linkmonitor::/monitor::--'
]
/**
 * 其余不在更多应用中的页面
 */

export const disPlayModuleRouteMap = moduleRouteMap.concat([
    // ebatch,esb,im,mc,elog 待定
    'ebatch::/ebatch::/mobile/ebatch',
    'escheduler::/escheduler::/mobile/escheduler',
    'esearch::/esearch::/mobile/esearch',
    'elog::/elog::/mobile/elog',
    'systemei::/systemei::/mobile/systemei',
    'voice::/voice::/mobile/voice',
    'datasecurity::/datasecurity::/mobile/datasecurity',
    'security::/security::/mobile/security',
    'intcenter::/intcommon::--',//集成公共服务
    'esb::/esb::--',//集成引擎
    'intunifyauthserver::/authserver::--',
    'intexchange::/intexchange::--',
    'intexchange::/bs/intexchange::--',
    'ecode::/ecode::--',
    'intias::/intias::--',//档案集成
    'ebuilder::/ebdapp::--',
    'ebuilder::/ebdform::--',
    'ebuilder::/ebdfpage::--',
    'ebuilder::/ebddesigner::--',
    'ebuilder::--::/mobile/ebdfpage',
    'hrsync::/intcenterhr::--',
    'intlogin::/intcenter/intlogin::--',
    'intunifyauth::/iaauthclient::--',
    'intmail::/intmail::--',

], managerRouteMap);

export const freepassPaths = [
    '/sp/openapi/base/doc/',
    '/sp/openapi/base/scenes/',
    '/sp/openapi/base/example/',
    '/sp/doc/docShare/',
    '/sp/profile/msignature',
    '/sp/em/popup',
    '/sp/em/browser',
    '/sp/formreport/distribute',
    '/mobile/eb/wechat/inviteshare',
    '/mobile/eb/nopassport',
    '/mobile/inc/invoicedetail',
    '/sp/integration/oauth2.0/logout',
    '/sp/integration/cas/logout'
]
export const licenseWhiteMap = [
    '/sp/doc/wpsEdit',
    '/sp/doc/wpsFile',
    '/sp/doc/docPreview',
    '/sp/doc/freepass/docPreview'
];
export const appWhiteMap = [
    '/sp/doc/wpsEdit',
    '/sp/doc/wpsFile',
    '/sp/doc/docPreview',
    '/sp/doc/freepass/docPreview',
    '/sp/signcenter/qysCommonPage',
    '/sp/workflow/pathset/actionDesigner'
];
export const wsBlackList = [
    '/sp/ebdapp/cloud/preview/'
]
export const thirdAppUaReg = /(MicroMessenger|wxwork|dingtalk|taurusapp|lark|qing|welink|cloudlink)/i;